import { Pipe, PipeTransform } from '@angular/core';
import { TranslationPipe } from 'src/shared/pipes/translation.pipe';
import { AddressModel } from 'src/shared/models/address.model';

@Pipe({
  name: 'tidyPropertyDetails'
})
export class TidyPropertyDetailsPipe implements PipeTransform {

  transform(address: Partial<AddressModel> | null | undefined): string | null {
    if (!address) {
      return null;
    }

    const t = new TranslationPipe();
    const bedBathParts: string[] = [];

    if (address.bed_count) {
      const label = address.bed_count === 1 ? t.transform('Bed') : t.transform('Beds');
      bedBathParts.push(`${address.bed_count} ${label}`);
    }

    if (address.bath_count) {
      const label = address.bath_count === 1 ? t.transform('Bath') : t.transform('Baths');
      bedBathParts.push(`${address.bath_count} ${label}`);
    }

    const bedBath = bedBathParts.join(' / ');

    if (address.living_area_sqft) {
      const sqft = `${address.living_area_sqft.toLocaleString()} ${t.transform('sq ft')}`;
      return bedBath ? `${bedBath} · ${sqft}` : sqft;
    }

    return bedBath || null;
  }

}
